/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Rate_LimitedInputs */



/**
* | output |
* | --- |
* | "The source limited how much we may read and did not recover in time. Retry later." |
*
* @param {Embedding_Error_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_rate_limited = /** @type {((inputs?: Embedding_Error_Rate_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Rate_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Quelle hat die Zugriffsmenge begrenzt und sich nicht rechtzeitig erholt. Versuchen Sie es später erneut.")
	return /** @type {LocalizedString} */ ("The source limited how much we may read and did not recover in time. Retry later.")
});